export const msalConfig = {
  auth: {
    clientId: "8eea82c4-f86f-4164-92e7-11b300837827",
    authority:
      "https://login.microsoftonline.com/afdd2115-db40-4711-bd96-fee5c7f7e6ec", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})

    // PROD
    // redirectUri: "https://dms.ctaxcrm.com/callback",

    // DEV
    // redirectUri: "https://ctaxdms.nablasol.net/callback",

    // Local
    redirectUri: "http://localhost:3001/callback",
  },
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
